import store from "../store";
import request from "request";
import { baseUrl } from '../../vue.config.js';

export default {
    authenticate: function(provider) {
        const domain = store.getters.AWS_COGNITO_USER_POOL_DOMAIN;
        const clientId = store.getters.AWS_COGNITO_CLIENT_ID;
        const type = "token";
        const scope = "EB_API/events.read EB_API/guests.read  EB_API/accounts.read";
        const callback = window.location.protocol + "//" + window.location.host + baseUrl + "login";
        // Save the 'verification' value, so it can be verified later to prevent CSRF attacks
        const verification = generateVerification();

        store.commit("setVerification", verification);

        if (provider !== undefined) {
            // Go straight to the provider, skipping the hosted UI
            window.location.href = "https://" + domain + "/authorize?identity_provider="
                + provider + "&response_type=" + type + "&client_id="
                + clientId + "&redirect_uri=" + callback
                + "&state="    + verification/* + "&scope=" + scope*/;
        } else {
            // Use the hosted UI
            window.location.href = "https://" + domain + "/login?response_type=" + type
                + "&client_id=" + clientId + "&redirect_uri=" + callback
                + "&state=" + verification/* + "&scope=" + scope*/;
        }
    },

    clientCredentials: async () => {
        const domain = store.getters.AWS_COGNITO_USER_POOL_DOMAIN;
        const clientId = store.getters.AWS_COGNITO_CLIENT_ID_CC;
        const clientSecret = store.getters.AWS_COGNITO_CLIENT_SECRET_CC;

        return new Promise((resolve, reject) => {
            request({
                url: "https://" + domain + "/oauth2/token",
                method: "POST",
                auth: {
                    user: clientId,
                    pass: clientSecret
                },
                form: {
                    "grant_type": "client_credentials"/*,
                    "scope": "EB_API/guests.read EB_API/events.read EB_API/accounts.read"*/
                }
            }, (err, res) => {
                if (res) {
                    const verification = generateVerification();
                    store.commit("setVerification", verification);
                    const json = JSON.parse(res.body);
                    console.log("Access Token:", json.access_token);
                    store.dispatch("authenticate", {
                        accessToken: json.access_token,
                        idToken: json.id_token,
                        expiresIn: json.expires_in,
                        verification: verification
                    });
                    resolve(json.access_token);
                } else {
                    reject(err);
                }
            });
        });
    },

    logout: () => {
        const domain = store.getters.AWS_COGNITO_USER_POOL_DOMAIN;
        const clientId = store.getters.AWS_COGNITO_CLIENT_ID;
        const callback = window.location.protocol + "//" + window.location.host + baseUrl + "logout";
        window.location.href = "https://" + domain + "/logout?client_id=" + clientId
			+ "&logout_uri=" + callback;
    }
};

// generateVerification creates a random string for including in the OAuth2
// request, which is then validated in the response.
function generateVerification() {
    var verification = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 32; i++) {
        verification += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return verification;
}